import { useMutation, useQueryClient } from 'libs/query'
import { useNavigate, useParams } from 'libs/router'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import type { FieldValues, UseFormSetError } from 'libs/form'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { applyCouponServerErrors } from '../../../utils/applyCouponServerErrors'

type UseEditCouponMutationProps = {
	setError: UseFormSetError<FieldValues>
}

export const useEditCouponMutation = ({ setError }: UseEditCouponMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	const { mutate: editCouponMutation, isPending: isEditCouponLoading } = useMutation({
		mutationFn: (data) => {
			return axiosPrivate.patch(apiRoutes.coupon(params.id as string), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.coupons.all })
			useToast({ type: 'success', message: t('Coupon edited') })()

			navigate('/coupons')
		},
		onError: (error) => {
			applyCouponServerErrors((error as any).response?.data, setError)
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editCouponMutation,
		isEditCouponLoading
	}
}
